export default function ListingDetail() {
    return(<></>)
};